import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useForm from "../hooks/useForm";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";

export default function Signup({ setShowLogin, user, setUserInfo, cartItems }) {
  const {
    handleChange,
    handleShippingAddressChange,
    signUpData,
    handleSubmit,
    errors,
    signUpError,
  } = useForm(user, setUserInfo, cartItems);

  const [states, setStates] = useState();
  const [cities, setCities] = useState();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const currentDate = new Date().toISOString().split("T")[0];

  useEffect(() => {
    axios
      .post("https://countriesnow.space/api/v0.1/countries/states", {
        country: "India",
      })
      .then((res) => {
        setStates(res.data.data.states);
        // console.log(res.data.data.states);
      });
  }, []);

  useEffect(() => {
    if (!signUpData.shippingAddress.state) {
      return;
    }
    axios
      .post("https://countriesnow.space/api/v0.1/countries/state/cities", {
        country: "India",
        state: signUpData.shippingAddress.state,
      })
      .then((res) => {
        setCities(res.data.data);
        // console.log(res.data.data);
      });
  }, [signUpData.shippingAddress.state]);

  return (
    <div className="z-20 w-full py-10 md:py-20 px-7 md:px-10 md:mx-56 my-10 md:my-24 bg-opacity-90 rounded-md border bg-white">
      <h1 className="mb-5 font-semibold text-3xl text-ambhosOrange">
        Create Account
      </h1>
      <hr className="mb-10" />
      <form
        className="flex flex-col"
        onSubmit={(e) => handleSubmit(e, "signUp")}
      >
        {signUpError && (
          <p className="px-2 py-1 bg-red-100 text-red-500 mb-5">
            <FontAwesomeIcon icon={faExclamationCircle} /> {signUpError}
          </p>
        )}
        <div className="flex flex-col md:flex-row justify-between mb-5">
          {/* Left Container */}
          <div className="flex flex-col space-y-5">
            <div className="flex flex-col md:flex-row space-y-5 md:space-y-0 md:space-x-5">
              <div className="flex flex-col">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={signUpData.firstName}
                  onChange={(e) => handleChange(e, "signUp")}
                  className="border-2 border-gray-500 rounded-md py-2 px-2 outline-none"
                />
                {errors.firstName && (
                  <small className="text-red-500 mt-0">
                    {errors.firstName}
                  </small>
                )}
              </div>
              <div className="flex flex-col">
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={signUpData.lastName}
                  onChange={(e) => handleChange(e, "signUp")}
                  className="border-2 border-gray-500 rounded-md py-2 px-2 outline-none"
                />
                {errors.lastName && (
                  <small className="text-red-500 mt-0">{errors.lastName}</small>
                )}
              </div>
            </div>
            <div className="flex flex-col">
              <input
                type="email"
                name="email"
                placeholder="Email address"
                value={signUpData.email}
                onChange={(e) => handleChange(e, "signUp")}
                className="w-full border-2 border-gray-500 rounded-md py-2 px-2 outline-none"
              />
              {errors.email && (
                <small className="text-red-500 mt-0">{errors.email}</small>
              )}
            </div>
            <div className="flex flex-col">
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={signUpData.password}
                onChange={(e) => handleChange(e, "signUp")}
                className="w-full border-2 border-gray-500 rounded-md py-2 px-2 outline-none"
              />
              {errors.password && (
                <small className="text-red-500 mt-0">{errors.password}</small>
              )}
            </div>
            <div className="flex flex-col">
              <div className="w-full flex justify-center items-center bg-white border-2 border-gray-500 rounded-md">
                <input
                  type={passwordVisible ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  value={signUpData.confirmPassword}
                  onChange={(e) => handleChange(e, "signUp")}
                  className="w-full rounded-md py-2 px-2 outline-none"
                />
                {passwordVisible ? (
                  <FontAwesomeIcon
                    onClick={() => setPasswordVisible(false)}
                    className="text-lg px-2 cursor-pointer"
                    icon={faEyeSlash}
                  />
                ) : (
                  <FontAwesomeIcon
                    onClick={() => setPasswordVisible(true)}
                    className="text-lg px-2 cursor-pointer"
                    icon={faEye}
                  />
                )}
              </div>
              {errors.confirmPassword && (
                <small className="text-red-500 mt-0">
                  {errors.confirmPassword}
                </small>
              )}
            </div>
          </div>
          {/* Right Container */}
          <div className="flex flex-col mt-5 md:mt-0 space-y-5">
            <div className="flex space-x-5 w-full">
              <div className="w-1/2 flex flex-col">
                <div className="w-full flex items-center border-2 border-gray-500 rounded-md p-2 bg-white">
                  <input
                    type="text"
                    name="dateOfBirth"
                    placeholder="Date Of Birth"
                    value={signUpData.dateOfBirth}
                    onChange={(e) => handleChange(e, "signUp")}
                    className="w-full outline-none"
                    max={currentDate}
                    onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => (e.target.type = "text")}
                  />
                  {/* <FontAwesomeIcon
                    icon={faCalendar}
                    className="-ml-3 text-gray-500 cursor-pointer"
                  /> */}
                </div>
                {errors.dob && (
                  <small className="text-red-500 mt-0">{errors.dob}</small>
                )}
              </div>
              <div className="w-1/2 flex flex-col">
                <select
                  name="gender"
                  value={signUpData.gender}
                  onChange={(e) => handleChange(e, "signUp")}
                  className="w-full border-2 border-gray-500 rounded-md p-2 outline-none"
                >
                  {/* if value==null then show error required */}
                  <option value="">Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
                {errors.gender && (
                  <small className="text-red-500 mt-0">{errors.gender}</small>
                )}
              </div>
            </div>
            <div className="flex flex-col">
              <input
                type="text"
                name="phoneNumber"
                placeholder="Phone Number"
                value={signUpData.phoneNumber}
                onChange={(e) => handleChange(e, "signUp")}
                className="w-full border-2 border-gray-500 rounded-md py-2 px-2 outline-none"
              />
              {errors.phoneNumber && (
                <small className="text-red-500 mt-0">
                  {errors.phoneNumber}
                </small>
              )}
            </div>
            <div className="flex flex-col">
              <input
                type="text"
                name="address"
                placeholder="Address"
                value={signUpData.shippingAddress.address}
                onChange={(e) => handleShippingAddressChange(e)}
                className="w-full border-2 border-gray-500 rounded-md py-2 px-2 outline-none"
              />
              {errors.address && (
                <small className="text-red-500 mt-0">{errors.address}</small>
              )}
            </div>
            <div className="flex space-x-5">
              <div className="w-full flex flex-col">
                <select
                  name="state"
                  value={signUpData.shippingAddress.state}
                  onChange={(e) => handleShippingAddressChange(e)}
                  className="md:w-36 w-full border-2 border-gray-500 rounded-md p-2 outline-none"
                >
                  <option value="">State</option>
                  {states?.map((state) => (
                    <option key={state.state_code} value={state.name}>
                      {state.name}
                    </option>
                  ))}
                </select>
                {errors.state && (
                  <small className="text-red-500 mt-0">{errors.state}</small>
                )}
              </div>
              <div className="w-full flex flex-col">
                <select
                  name="city"
                  value={signUpData.shippingAddress.city}
                  onChange={(e) => handleShippingAddressChange(e)}
                  className="md:w-32 w-full border-2 border-gray-500 rounded-md p-2 outline-none"
                >
                  <option value="">City</option>
                  {cities?.map((city) => (
                    <option key={city} value={city}>
                      {city}
                    </option>
                  ))}
                </select>
                {errors.city && (
                  <small className="text-red-500 mt-0">{errors.city}</small>
                )}
              </div>
              <div className="w-full flex flex-col">
                <input
                  type="text"
                  name="pincode"
                  maxLength="6"
                  placeholder="Pincode"
                  value={signUpData.shippingAddress.pincode}
                  onChange={(e) => handleShippingAddressChange(e)}
                  className="md:w-32 w-full border-2 border-gray-500 rounded-md py-2 px-2 outline-none"
                />
                {errors.pincode && (
                  <small className="text-red-500 mt-0">{errors.pincode}</small>
                )}
              </div>
            </div>
          </div>
        </div>
        <button
          className="md:w-1/5 rounded-md py-2 px-2 text-lg bg-ambhosOrange text-white"
          type="submit"
        >
          Sign up
        </button>
      </form>
      <p className="mt-3">
        Already have an Account?{" "}
        <button
          className="text-ambhosOrange font-semibold"
          onClick={() => setShowLogin(true)}
        >
          Login here
        </button>
      </p>
    </div>
  );
}
